// extracted by mini-css-extract-plugin
export default {"main":"ModalAddProduct_main__qHbik","container":"ModalAddProduct_container__ebPur"};